import { Component, Input, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef, OnInit } from '@angular/core';
import * as L from 'leaflet';

@Component({
  selector: 'nlf-map-display',
  templateUrl: './map-display.component.html',
  styleUrls: ['./map-display.component.css']
})
export class NlfMapDisplayComponent {
  @Input() lineString: []; //[number, number, number?][] = [];

  showMap: boolean;
  tileLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  })
  mapOptions: L.MapOptions = {
    layers: [
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      })
    ],
    zoom: 2,
    center: L.latLng(53, 10)
  };

  layers: L.Layer[]; // = [];

  ngOnInit() {
    this.updatePath();
  }

  get options(){
    return {
    layers: [
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '...' })
    ],
    zoom: 5,
    center: L.latLng(46.879966, -121.726909)
    }
  };

  onMapReady(map: L.Map) {
    console.log('Map ready');
    this.updatePath(map);
  }

  /**@Input() set lineString(value: [number, number][] | null) {
    this.lineString = value ? [...value] : [];
    if (this.layers.length > 0 || this.lineString.length > 0) {
      this.updatePath();
    }
  }**/

  private updatePath(map?: L.Map) {
    console.log('updatePath, lineString:', this.lineString);
    if(this.lineString.length > 0 && !!map) {
      map.addLayer(L.polyline(this.lineString, { color: 'blue' }));
      
      map.fitBounds(L.polyline(this.lineString).getBounds());
      
      map.addLayer(L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '...' }));
      map.invalidateSize(); //setTimeout(()=>, 1000);
    }
  }

}